import { Button, Tooltip, CircularProgress } from '@material-ui/core';
import { KeyboardArrowDown } from '@material-ui/icons';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { TranslationIDs, AnalyticsEventKeys } from '../../constants';
import { Dispatch, iRootState } from '../../redux/store';
import useStyles from '../../useStyles';
import AttachmentsHelper from './AttachmentsHelper';

const AttachmentsMenuButton = function AttachmentsMenuButton(): React.ReactElement {
  const dispatch = useDispatch<Dispatch>();

  const hideTooltip = useSelector(
    (state: iRootState) => state.attachmentsMenu.hideTooltip
  );
  const menuOpen = useSelector(
    (state: iRootState) => state.attachmentsMenu.open
  );
  const isSigning = useSelector(
    (state: iRootState) => state.loading.effects.signPdf.sign
  );
  const classes = useStyles();

  const tooltipOpen = !hideTooltip && !menuOpen;

  const onClick = function handleOnClick(
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ): void {
    dispatch.analytics.sendEvent({
      eventType: AnalyticsEventKeys.DocumentsMenuClicked
    });
    dispatch.attachmentsMenu.toggleOpen(event.currentTarget);
  };

  const endIcon = isSigning ? (
    <CircularProgress color='inherit' size={16} />
  ) : (
    <KeyboardArrowDown />
  );

  return (
    <Tooltip
      title={<AttachmentsHelper />}
      arrow
      open={tooltipOpen}
      interactive
      classes={{
        tooltip: classes.attachmentTooltip,
        arrow: classes.attachmentTooltipArrow
      }}
    >
      <Button
        color='inherit'
        disabled={isSigning}
        onClick={onClick}
        endIcon={endIcon}
      >
        <FormattedMessage
          id={TranslationIDs.documents}
          defaultMessage='Documents'
        />
      </Button>
    </Tooltip>
  );
};

export default AttachmentsMenuButton;
